/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Pausereasoncolor2Inputs */

const en_entity_pausereasoncolor2 = /** @type {(inputs: Entity_Pausereasoncolor2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause Reason Color`)
};

const de_entity_pausereasoncolor2 = /** @type {(inputs: Entity_Pausereasoncolor2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe`)
};

/**
* | output |
* | --- |
* | "Pause Reason Color" |
*
* @param {Entity_Pausereasoncolor2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_pausereasoncolor2 = /** @type {((inputs?: Entity_Pausereasoncolor2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Pausereasoncolor2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_pausereasoncolor2(inputs)
	return de_entity_pausereasoncolor2(inputs)
});
export { entity_pausereasoncolor2 as "entity_pauseReasonColor" }